import { createTheme, responsiveFontSizes } from "@mui/material/styles";

let theme = createTheme({
  palette: {
    primary: {
      main: "#000",
    },
    secondary: {
      main: "#fff",
    },
    background: {
      default: "#f5f5f5",
    },
    text: {
      primary: "#333", // Text color
    },
  },
  typography: {
    fontFamily: "BasisGrotesqueArabicPro,Roboto, Helvetica, sans-serif",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    fontWeightBlack: 900,
    h1: { fontWeight: 900 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 500 },
    body1: { fontWeight: 400 },
    body2: { fontWeight: 300 },
  },
  breakpoints: {
    xxs: 0,
    xs: 300,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
});

theme = responsiveFontSizes(theme);

export default theme;
